export const ReplaceKey = (o, oldKey, newKey) => {
    if (oldKey !== newKey) {
        Object.defineProperty(o, newKey, Object.getOwnPropertyDescriptor(o, oldKey));
        delete o[oldKey];
    }

    return o;
};